import {
  BackgroundColour,
  BorderColour,
  BorderThickness,
  BorderType,
  FontFamily,
  FontSize,
  FontWeight,
  Margin,
  Padding,
  TextColour,
} from "../../../CommonProperties";

const CouponControlFormStages = [
  {
    title: "Content",
    sections: [
      {
        name: "Options",
        fields: [
          {
            name: "code",
            description: "",
            label: "Code Text",
            type: "nvarchar",
          },
          {
            name: "redeemFrom",
            description: "",
            label: "Redeem From Text",
            type: "nvarchar",
          },
          {
            name: "redeemBy",
            description: "",
            label: "Redeem By Text",
            type: "nvarchar",
          },
          {
            name: "useBy",
            description: "",
            label: "Use By Text",
            type: "nvarchar",
          },
          {
            name: "redeemLink",
            description: "",
            label: "Redeem Link",
            type: "nvarchar",
          },
          {
            name: "termsLink",
            description: "",
            label: "Terms Link",
            type: "nvarchar",
          },
        ],
      },
      {
        name: "Locale",
        fields: [
          {
            name: "localeCode",
            description: "",
            label: "Locale Code",
            type: "nvarchar",
          },
        ],
      },
      {
        name: "Date Format",
        fields: [
          {
            name: "longDateFormat",
            description: "",
            label: "Long Date Format",
            type: "nvarchar",
          },
        ],
      },
    ],
  },
  {
    title: "Style",
    sections: [
      {
        name: "Content",
        fields: [
          BackgroundColour(""),
          TextColour(""),
          FontFamily(""),
          FontSize(""),
          FontWeight(""),
          Margin(""),
          Padding(""),
          BorderType(""),
          BorderThickness(""),
          BorderColour(""),
        ],
      },
    ],
  },
];

export default CouponControlFormStages;
